export default __webpack_public_path__ + "resources/icons/n442-57da.png";